// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Axios from 'axios'
import VueViewload from 'vue-viewload'
import Public from './components/public/Public.vue';
var VueCookie = require('vue-cookie');
Vue.config.productionTip = false;
Vue.prototype.classType = {
  NavRecommend:'recommend',
  Category:'category',
  Recommend:1,
  Banner:3,
  newBanner:8,
  JDBanner:15,
  newHomePage:10
};
Vue.prototype.headType={
  h5Main:0,
  recommendMain:1,
  recommend:2,
  cidHead:3,
  searchResultHead:4,
  searchHead:5,
  share:6,
  wxShare:7,
  wxDetail:8,
  wxQun:9,
  JDBanners:10
};
Vue.prototype.orderEmon = {
  NORMAL:0,
  CHAOZHI:1,
  PRICEDESC:2,
  PRICEASC:3,
  SALENUM:4
};
Vue.prototype.showType={
  APP:0,
  H5:1
};
Vue.prototype.cdns="";
Vue.prototype.public = new Vue(Public);
Vue.prototype.baseParam = 'ali=1';
Vue.prototype.jumpToView=function(type,param,desc){
  let p = Vue.prototype.public;
  p.type = type;
  switch (type){
    case Vue.prototype.headType.h5Main:{
      window.location.href= "#/";
      break;
    }
    case Vue.prototype.headType.recommendMain:{
      p.classParam = param;
      window.location.href= "#/recommend?headType=1&q="+window.encodeURIComponent(param);
      window.location.href= "#/recommend";
      break;
    }
    case Vue.prototype.headType.recommend:{
      p.classParam = param;
      p.title = desc;
      window.location.href= "#/recommend?headType=2&title="+window.encodeURI(desc)+"&q="+window.encodeURIComponent(param);
      break;
    }
    case Vue.prototype.headType.cidHead:{
      p.cidParam = param;
      p.cid = desc;
      window.location.href= "#/recommend?headType=3&cid="+desc+"&q="+window.encodeURIComponent(param);
      break;
    }
    case Vue.prototype.headType.searchResultHead:{
      p.keyParam = param;
      p.key = desc;
      window.location.href= "#/recommend?headType=4&keyword="+window.encodeURI(desc)+"&q="+window.encodeURIComponent(param);
      break;
    }
    case Vue.prototype.headType.JDBanners:{
      window.location.href= "#/jdIdx"+param;
      break;
    }
    case Vue.prototype.headType.searchHead:{
      if(typeof desc!='undefined'){
        p.key = desc;
        window.location.href= "#/search?keyword="+window.encodeURI(desc);
      }else{
        p.key = '';
        window.location.href= "#/search";
      }
      break;
    }
    default:{

    }
  }
};
Vue.prototype.taoConfig = 'https://item.taobao.com/item.htm?id=';
Vue.prototype.weiXinConfig = window.location.origin + '/assets/taoke/link.html?uuid=';
Vue.prototype.watcher = new Vue();
Vue.prototype.http=Axios;
Axios.interceptors.request.use(function(config) {
  config.withCredentials = true;
  return config;
});
Vue.prototype.isWeixin=navigator.userAgent.toLowerCase().match(/MicroMessenger/i)==("micromessenger");
Vue.prototype.angentType = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)?'ios':'android';
Vue.prototype.isAndroid = navigator.userAgent.toLowerCase().indexOf('android') > -1 || navigator.userAgent.toLowerCase().indexOf('linux') > -1;
Vue.prototype.isIos = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
Vue.prototype.isPc = !(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i));;
Vue.use(VueViewload);
Vue.use(VueCookie);
Vue.prototype.config = "";
Vue.prototype.https = {
  getTaos:Vue.prototype.config+'/taokeouts/',
  getTaoClass:Vue.prototype.config+'/getTaoClassesPublish/',
  count:Vue.prototype.config+'/t',
  getClick:Vue.prototype.config+'/getclick/',
  //sysInit:Vue.prototype.config+'/iossysinit?indexVersion=173',
  sysInit:Vue.prototype.config+'/sysinit/1.0?indexVersion=173&sex=2&appVersion=202',
  getCDN:Vue.prototype.config+'/getCDN',
  getHotWord:Vue.prototype.config+'/hotkeyword',
  getLikeWord:'https://suggest.taobao.com/sug?code=utf-8&q=',
  getTaoke:Vue.prototype.config+'/taoout/',
  getProduct:Vue.prototype.config+'/getoutproduct',
  downloadApp:Vue.prototype.config+'/downloadApp',
  getPkgName:Vue.prototype.config+'/b/getNameAndVersion/',
  jumpoutwx:Vue.prototype.config+'/jumpoutwx',
  mpGoodsDetail: window.location.origin + "/assets/web/mpWeb/mpGoodsDetail.html?inMp=1"
};
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js